import { Container, Grid, Box } from "@mui/material"

import NoResultsSVG from "../../svg/search/noResults.svg"
import { Phone } from "../../components/i18n/Contact"

import Icon from "@mdi/react"
import { mdiSend, mdiCheckboxBlankCircle } from "@mdi/js"

import { openingHours } from "@secureo/common/config/contact"

const NoResults = () => {
	return (
		<Box my={5} py={5}>
			<Container maxWidth="md">
				<Grid container spacing={3}>
					<Grid item xs={12} md={7}>
						<h1 style={{ margin: "0" }}>Ihre Suche ergab leider keine Ergebnisse</h1>
						<ul style={{ paddingLeft: "20px" }}>
							<li>Überprüfen Sie Ihre Suchanfrage auf Rechtschreibfehler</li>
							<li>Versuchen Sie eine andere Formulierung</li>
							<li>Möglicherweise ist Ihre Suchanfrage zu speziefisch </li>
						</ul>
					</Grid>
					<Grid item xs={12} md={5}>
						<div style={{ width: "100%" }}>
							<NoResultsSVG />
						</div>
					</Grid>
					<Grid item xs={12}>
						<p className="h5">
							Unsere kompetenten Mitarbeiter helfen Ihnen gerne weiter
						</p>
						<p>{openingHours}</p>
						<div style={{ display: "flex", fontWeight: "bold" }}>
							<div>
								<Phone />
							</div>
							<Box mx={4} style={{ display: "flex" }}>
								<Icon path={mdiSend} size={0.75} color="grey" />
								<Box ml={1}>E-Mail schreiben</Box>
							</Box>
							<div style={{ display: "flex" }}>
								<Icon path={mdiCheckboxBlankCircle} size={0.75} color="#7abfac" />
								<Box ml={1}>Chatten Sie mit uns</Box>
							</div>
						</div>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}

export default NoResults
